<template>
  <div class="Whitelist-customer-content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><svg-icon icon-class="Whitelist" />Customer Whitelist </span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="createCustomWhitelist"
          ><i class="el-icon-plus"></i> Add Whitelist</el-button
        >
      </div>
      <div>
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
        >
          <!-- <el-table-column label="Member Code" prop="memberCode" width="120" align="center">
            </el-table-column> -->
          <el-table-column label="Member Code" prop="memberCode" min-width="200">
          </el-table-column>
          <el-table-column label="Name" prop="name" min-width="200">
          </el-table-column>
          <el-table-column
            label="Exactly Match"
            prop="exactlyMatch"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="`${!scope.row.exactlyMatch ? 'info' : ''}`">
                {{ scope.row.exactlyMatch ? "Yes" : "No" }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column label="Action" prop="uid" width="180" align="center">
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                @click="editWhitelist(scope.row.uid, scope.row.plusuid)"
              >
                Edit
              </el-button>
              <el-button
                type="danger"
                size="mini"
                @click="deleteWhitelist(scope.row.uid, scope.row.name, scope.row.plusuid)"
              >
                Del
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <el-dialog
      :title="titleDialog"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        :model="formData"
        :rules="formDataRules"
        label-width="120px"
        size="mini"
      >
      <el-form-item label="Customer" prop="plusUID">
          <model-list-select
            :list="dataCustomer"
            v-model="formData.plusUID"
            option-value="plusuid"
            option-text="membercode"
            placeholder="All"
          >
          </model-list-select>
        </el-form-item>
        <el-form-item label="Name" prop="name">
          <el-input v-model="formData.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Exactly Match">
          <el-select v-model="formData.exactlyMatch">
            <el-option label="Yes" :value="true"></el-option>
            <el-option label="No" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="submitWhitelist" :loading="submitting"
          >Submit</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { ModelListSelect } from "vue-search-select";
import { getCustomerDropdown } from "@/api/customer";
import {
  getWhitelistByProjectUID,
  createCustomWhitelist,
  getCustomWhitelistByUID,
  putCustomWhitelistByUID,
  deleteCustomWhitelistByUID,
} from "@/api/firewall-whitelist";
export default {
  components:{
    ModelListSelect,
  },

  data() {
    return {
      loading: false,
      submitting: false,
      dialogFormVisible: false,
      actionDialog: "add",
      enterTimeout: null,
      editUID: "",
      titleDialog: "Create Whitelist",
      dataCustomer: [],
      tableData: [],
      formData: {
        name: "",
        plusUID: "",
        exactlyMatch: false,
      },
      formDataRules: {
        plusUID: [
          { required: true, message: "Please select customer", trigger: "blur" },
        ],
        name: [
          { required: true, message: "Please input name", trigger: "blur" },
        ],
        
      },
      query: {
        start: 0,
        length: this.pageSize,
        order: "DESC",
      },
      recordTotal: 0,
      pageSize: 10,
      currentPage: 1,
    };
  },
  methods: {
    getCustomWhitelist() {
      this.loading = true;
      getWhitelistByProjectUID(this.$route.params.project_uid).then(
        ({ result, data }) => {
          this.loading = false;
          if (result) {
            this.tableData = data;
            this.getCustomerDropdown(this.$route.params.project_uid)
          }
        }
      );
    },
    getCustomerDropdown(project_uid){
      this.dataCustomer = []
      getCustomerDropdown(project_uid).then(({result, data, message})=>{
        if(result){
          this.dataCustomer = data;
        }        
      })
    },
   
    createCustomWhitelist() {
      this.resetForm();
      this.dialogFormVisible = true;
      this.actionDialog = "add";
      this.titleDialog = "Create Whitelist";
    },
    submitWhitelist() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.submitting = true;
          var plusUID = this.formData.plusUID
          var model = JSON.parse(JSON.stringify(this.formData));
          delete model.plusUID;
          if (this.actionDialog === "add") {
            createCustomWhitelist(
              this.$route.params.project_uid,
              plusUID,
              model
            ).then(({ result, message }) => {
              this.submitting = false;
              if (result) {
                this.dialogFormVisible = false;
                this.getCustomWhitelist();
                this.resetForm();
              } else {
                this.$message.error(message);
              }
            });
          } else {
            putCustomWhitelistByUID(this.editUID, plusUID, model).then(
              ({ result, message }) => {
                this.submitting = false;
                if (result) {
                  this.dialogFormVisible = false;
                  this.getCustomWhitelist();
                  this.resetForm();
                } else {
                  this.$message.error(message);
                }
              }
            );
          }
        }
      });
    },
    editWhitelist(uid, plusUID) {
      this.loading = true;
      this.editUID = uid;
      this.titleDialog = "Edit Whitelist";
      getCustomWhitelistByUID(this.editUID, plusUID).then(
        ({ result, data }) => {
          this.loading = false;
          if (result) {
            this.formData.name = data.name;
            this.formData.plusUID = data.plusuid;
            this.formData.exactlyMatch = data.exactlyMatch ? true : false;
            this.actionDialog = "edit";
            this.dialogFormVisible = true;
          }
        }
      );
    },
    deleteWhitelist(uid, name, plusUID) {
      this.$confirm(`This will delete ${name} . Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          deleteCustomWhitelistByUID(uid, plusUID).then(
            ({ result, message }) => {
              this.loading = false;
              if (result) {
                this.getCustomWhitelist();
              } else {
                this.$message.error(message);
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    resetForm() {
      this.formData.name = "";
      this.formData.plusUID = "";
      this.formData.exactlyMatch = false;
      this.editUID = "";
    },
  },
  mounted() {
    setTimeout(() => {
      this.getCustomWhitelist();
    }, 1000);
  },
};
</script>

<style>
</style>